// extracted by mini-css-extract-plugin
export default {"bottomDiv":"FooterAppendix_bottomDiv__TdW3y","iconContainer":"FooterAppendix_iconContainer__wTKRl"};